import { render, staticRenderFns } from "./PostAttachment.vue?vue&type=template&id=55256472&scoped=true"
import script from "./PostAttachment.vue?vue&type=script&lang=js"
export * from "./PostAttachment.vue?vue&type=script&lang=js"
import style0 from "./PostAttachment.vue?vue&type=style&index=0&id=55256472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55256472",
  null
  
)

export default component.exports